export const CardStatusType = {
    StatusOpen: "StatusOpen",
    StatusClosed: "StatusClosed"
}